import toast, { type ToastOptions } from 'react-hot-toast';

const pill = (background: string, color: string) => ({
  borderRadius: '9999px',
  padding: '10px 22px',
  fontSize: '14px',
  fontWeight: 500,
  boxShadow: '0 8px 28px rgba(15, 23, 42, 0.14)',
  maxWidth: 'min(90vw, 440px)',
  textAlign: 'center' as const,
  background,
  color,
});

const baseOptions: Partial<ToastOptions> = {
  position: 'top-center',
};

export const toolToast = {
  success: (message: string) =>
    toast.success(message, {
      ...baseOptions,
      duration: 2800,
      style: pill('#15803d', '#fff'),
      iconTheme: { primary: '#fff', secondary: '#15803d' },
    }),

  error: (message: string) =>
    toast.error(message, {
      ...baseOptions,
      duration: 4200,
      style: pill('#b91c1c', '#fff'),
      iconTheme: { primary: '#fff', secondary: '#b91c1c' },
    }),

  info: (message: string) =>
    toast(message, {
      ...baseOptions,
      duration: 3200,
      icon: null,
      style: pill('#334155', '#f8fafc'),
    }),

  warning: (message: string) =>
    toast(message, {
      ...baseOptions,
      duration: 3600,
      icon: null,
      style: pill('#c2410c', '#fff'),
    }),
};
